import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { tableConfig } from '../../../../../../settings/index';
import Api from '../../../../../../helpers/api';
import { sendRequest } from '../../../../../../helpers/saga';
import { logger } from '../../../../../../helpers/logger';
import notifications from '../../../../../../redux/notifications/actions';
import { withTZ } from '../../../../../../helpers/dateTime';

function* loadData({ payload }) {
  const { isSettingsPage } = payload;
  const api = isSettingsPage ? new Api('orientations/:id/logs') : new Api('orientations/sessions/:id/logs');
  const id = isSettingsPage ? payload.orientation_id : payload.session_id;
  try {
    const {
      page = 1,
      pageSize = tableConfig.pageSize,
      column = 'created_at',
      order = 'descend',
      filter,
      trigger = [],
      user = [],
    } = payload;

    if (payload['created_at[start_time]']) {
      const date = payload['created_at[start_time]'];

      payload['created_at[start_time]'] = `${withTZ(date).format('YYYY-MM-DDTHH:mm:ss.SSS')}Z`;
    }

    if (payload['created_at[end_time]']) {
      const date = payload['created_at[end_time]'];

      payload['created_at[end_time]'] = `${withTZ(date).format('YYYY-MM-DDTHH:mm:ss.SSS')}Z`;
    }

    const result = yield call(
      sendRequest,
      api.load,
      { search: { ...payload, page, pageSize, column, order, filter, trigger, user }, id },
      notifications.REQUEST_ERROR,
    );

    if (result && result.data && result.data.success && result.data.success.data) {
      const { data, records, totalCount, filteredCount, sortable_columns, filters } = result.data.success.data;

      yield put(
        actions.loadDataSuccess({
          data: isSettingsPage ? records : data,
          filters,
          total: totalCount,
          filteredTotal: filteredCount,
          sortableColumns: sortable_columns,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD_REQUEST, loadData)]);
}
